$('.expand-collapse__title').click(function() {
  const $expandCollapse = $(this).parent(),
        $expandCollapseContent = $expandCollapse.find('.expand-collapse__content');

  if($expandCollapse.hasClass('open')){
    $expandCollapse.removeClass('open');
    $expandCollapseContent.css('max-height', 0);
  } else {
    $expandCollapse.addClass('open');
    $expandCollapseContent.css('max-height', $expandCollapseContent.prop('scrollHeight') + "px");
  }
});